import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../../../components/common-modal/CommonModal';
import SourceImage from './SourceImage';

import scss from './SourceImageModal.module.scss';

function SourceImageModal({ isOpen, onClose, sourceImageId, onGetImage }) {
  const { t } = useTranslation('id8');

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <div className={scss.wrapper}>
        <h2 className={scss.title}>{t('sourceImage')}</h2>

        <SourceImage promptId={sourceImageId} className={scss.sourceImage} onGetImage={onGetImage} />
      </div>
    </CommonModal>
  );
}

export default SourceImageModal;
